import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATUS,
} from 'services/api';
import {
  AdvancedSearchItem,
  createAddSearchReducer,
  createDeleteSearchReducer,
  createFetchSearchReducer,
  createUpdateSearchReducer,
} from 'services/search';
import { combineReducers } from 'redux';

import { CurrenciesActionTypes } from './actions';
import { transformCurrency } from '../transformations';

const initialState = {
  _status: INITIAL_API_STATUS,
  items: [],
};

/**
 * Transforms search item received from server to our format
 * @param response
 */
export const transformSearch = (serverSearchItem: any): AdvancedSearchItem => {
  return {
    id: serverSearchItem.id,
    columns: serverSearchItem.columns,
    searchName: serverSearchItem.searchName,
    isDefault: serverSearchItem.isDefault,
  };
};

const currencyRatesReducer = createApiReducer(
  [
    CurrenciesActionTypes.FETCH_CURRENCIES_START,
    CurrenciesActionTypes.FETCH_CURRENCIES_SUCCESS,
    CurrenciesActionTypes.FETCH_CURRENCIES_FAILURE,
  ],
  (data) => ({ items: data.results.map(transformCurrency) }),
  (data) => data
);

const fetchSearchReducer = createFetchSearchReducer('currency');
const addSearchReducer = createAddSearchReducer('currency');
const updateSearchReducer = createUpdateSearchReducer('currency');
const deleteSearchReducer = createDeleteSearchReducer('currency');

const currencyChainedReducers = chainReducers(
  initialState,
  currencyRatesReducer
);

const searchChainedReducers = chainReducers(
  initialState,
  fetchSearchReducer,
  addSearchReducer,
  updateSearchReducer,
  deleteSearchReducer
);

export default combineReducers({
  currencies: currencyChainedReducers,
  searches: searchChainedReducers,
});
